export default "__VITE_ASSET__Dv3o$ECj__"